module.exports = __webpack_public_path__ + "static/media/cody_do.efaa6731.png";